import { CrFilter } from '../../../customer-review-star-filter/types';
import { SortParameter } from '../../types';

export const fetchReviewListHtml = async (
    productId: string,
    crFilter?: CrFilter,
    sortParameter?: SortParameter,
    page?: number
): Promise<string> => {
    const searchParams = new URLSearchParams();
    if (crFilter) {
        searchParams.set('filter', crFilter);
    }
    if (sortParameter) {
        searchParams.set('sort', sortParameter);
    }
    if (page) {
        searchParams.set('page', page.toString());
    }
    const response = await fetch(`/dcs/cr/reviews/${productId}?${searchParams}`);
    return response.text();
};
